import React from 'react'
import {connect} from 'dva'
import {routerRedux} from 'dva/router'
import moment from 'moment'
import {parse, stringify} from 'query-string'
import {Button, Divider, Icon, Modal, Table} from 'antd'
import styles from "./index.module.less"
import GroupApplyStatus from "../../components/GroupApplyStatus"
import Info from "./Info"

const namespace = 'groupapplylist'

const Component = ({
                     model,
                     loading,
                     location,
                     dispatch,
                     app,
                   }) => {

  location.query = parse(location.search)
  const {query, pathname} = location
  const {list, pagination, modalVisible, currentItem} = model
  const {user} = app
  const columns = [
    {
      title: '订单编号',
      dataIndex: 'groupApplyNo',
    },
    {
      title: '团队名称',
      dataIndex: 'groupName',
    },
    {
      title: '入园日期',
      dataIndex: 'travelDate',
      render: (value) => moment(value).format('Y-MM-DD'),
    },
    {
      title: '联系人',
      dataIndex: 'contact',
    },
    {
      title: '状态',
      dataIndex: 'status',
      width: 120,
      render: (value) => <GroupApplyStatus value={value}/>
    },
    {
      title: '操作',
      width: 180,
      render: (text, record) => {
        const operations = [
          <a onClick={() => handleView(record)} style={{color: '#1685f5'}}>查看</a>
        ]
        if (record.status === 1) {
          operations.push(
            <Divider type={"vertical"}/>,
            <a onClick={() => handleCancel(record)} style={{color: '#d93026'}}>取消</a>,
          )
        }
        return operations
      },
    },
  ]

  const modalProps = {
    visible: modalVisible,
    maskClosable: false,
    width: 840,
    title: currentItem && currentItem.groupName,
    footer: null,
    onCancel() {
      dispatch({
        type: `${namespace}/hideModal`,
      })
    },
  }

  const handleRefresh = (newQuery) => {
    dispatch(routerRedux.push({
      pathname,
      search: stringify({
        ...query,
        ...newQuery,
      }),
    }))
  }

  const onLogout = () => {
    dispatch({
      type: 'app/logout',
    })
  }

  const handleCancel = (record) => {
    Modal.confirm({
      title: '确定要取消申请吗?',
      okType: 'danger',
      onOk() {
        dispatch({
          type: `${namespace}/cancel`,
          payload: record.objectId,
        })
          .then(() => handleRefresh())
      },
    })
  }

  const handleView = (record) => {
    dispatch({
      type: `${namespace}/showModal`,
      payload: {
        currentItem: record
      },
    })
  }

  const listProps = {
    scroll: {x: 800},
    rowKey: "objectId",
    columns,
    dataSource: list,
    loading: loading.effects[`${namespace}/query`],
    pagination,
    location,
    onChange(page) {
      handleRefresh({
        page: page.current,
        pageSize: page.pageSize,
      })
    },
  }

  return (
    <div className={styles['page-list']}>
      <h1>团队预约（{user && user.phoneNo}）</h1>
      <div className={styles.buttons}>
        <Button type="primary" href="../group-apply"><Icon type="plus"/>立即申请</Button> &nbsp;
        <Button onClick={onLogout}>退出</Button>
      </div>
      <Table {...listProps}/>
      {modalVisible && <Modal {...modalProps}>
        <Info item={currentItem} />
      </Modal>}
    </div>

  )
}

export default connect(({groupapplylist, app, loading}) => ({
  loading,
  model: groupapplylist,
  app,
}))(Component)
